import { UTCDate } from '../../../utils/dates';

export const formatExpiry = (isoExpiry: string): string => {
  const date = new UTCDate(isoExpiry);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${month}/${year}`;
};
